import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import _ from 'lodash';
import * as libraryActions from '~/library/actions';
import OptionsFilter from '~/components/OptionsFilter';
import { SOURCECLEAR_COMPONENTS } from '~/constants/ModelConstants';
type LibraryViewVersionProps = {
  libraryState: object;
  actions: object;
  navigationState: object;
};
class LibraryViewVersion extends React.Component<LibraryViewVersionProps, {}> {
  constructor(props, context) {
    super(props, context);
    this.delayedHandleCommitHashChange = _.debounce(this.handleCommitHashChange.bind(this), 300);
  }
  componentDidMount() {
    const { libraryState, navigationState } = this.props;
    const { component = {}, version = '' } = libraryState;
    const { libraryModel = {} } = component;
    const { latestRelease = {} } = libraryModel;
    const { version: latestReleaseVersion } = latestRelease;
    const { activeParams = {} } = navigationState;
    let activeVersion = activeParams.version
      ? activeParams.version
      : !_.isEmpty(component) && !version
      ? latestReleaseVersion || ''
      : version;
    this.props.actions.updateVersion(activeVersion);
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    const { libraryState } = nextProps;
    const {
      onlyVulnerableVersions,
      version: currentVersion,
      vulnerableVersions: libVulnVersions = [],
    } = libraryState;
    const vulnerableVersions = libVulnVersions || [];
    if (onlyVulnerableVersions && vulnerableVersions.length) {
      // if only vulnerable versions, check if the current version is in the list of vuln versions
      if (
        !_.find(vulnerableVersions, version => {
          return version.version === currentVersion;
        })
      ) {
        // if it isn't, trigger the first version in the list as the new current version
        this.triggerNewVersion(vulnerableVersions[0].version);
      }
    }
  }
  updateActiveVersionTab = versionTab => {
    this.props.actions.updateVersionTab(versionTab);
  };
  updateVersion = version => {
    this.triggerNewVersion(version);
  };
  getLatestCommitHashes(versions, version) {
    const versionObj = versions.find(versionObj => versionObj.version === version);
    return versionObj && versionObj.latestCommitsPreview;
  }
  handleCommitHashChange = commitHash => {
    this.props.actions.updateCommitHash(commitHash);
    this.triggerNewVersion(this.getCorrectVersion(), commitHash);
  };
  toggleVulnerableVersions = () => {
    this.props.actions.toggleOnlyVulnerableVersions();
  };
  triggerNewVersion(version) {
    const { libraryState = {} } = this.props;
    const { title, packageManager, language, versionTab, component = {} } = libraryState;
    const { libraryModel = {} } = component;
    const { id } = libraryModel;
    const params = {
      title,
      packageManager,
      componentId: id,
      language,
      tab: 'versions',
      version,
      versionTab: versionTab || 'vulnerabilities',
    };
    browserHistory.push(
      `/${SOURCECLEAR_COMPONENTS.VULNERABILITY_DATABASE.slug}/libraries/${params.title}/${
        params.language
      }/${params.packageManager}/lid-${params.componentId}/${params.tab}/${params.version}`
    );
  }
  getApplicableVersions() {
    const { libraryState } = this.props;
    const { onlyVulnerableVersions, component = {}, vulnerableVersions = [] } = libraryState;
    const { libraryModel = {} } = component;
    const { versions = [] } = libraryModel;
    if (onlyVulnerableVersions) {
      return vulnerableVersions;
    }
    return versions;
  }
  render() {
    const { libraryState } = this.props;
    const {
      vulnerabilities = [],
      onlyVulnerableVersions,
      vulnerableVersions: vulnerableVersionsList = [],
      version: currentVersion,
    } = libraryState;
    //const currentVersion = this.getCorrectVersion();
    const vulnerableVersions =
      (vulnerableVersionsList &&
        vulnerableVersionsList.filter(version => version.version !== 'HEAD')) ||
      [];
    const versions = this.getApplicableVersions() || [];
    const hasVersions = versions.filter(version => version.version !== 'HEAD').length > 0;
    const componentHasVulns =
      vulnerabilities && vulnerabilities.length && vulnerableVersions && vulnerableVersions.length;
    const headerElements = [];
    //Urls
    let vulnerableVersionToggleElement;
    if (!versions || !versions.length) {
      return <div className="mt">No versions available.</div>;
    }
    const versionsArr = versions
      .filter(version => version.version !== 'HEAD')
      .map(version => ({
        value: version.version,
        label: version.version,
      }));
    if (componentHasVulns) {
      vulnerableVersionToggleElement = (
        <div className="grid__item col-1-3">
          <label className="label--checkbox mb0 phone--pt- pl--">
            <input
              type="checkbox"
              name="versions"
              onChange={this.toggleVulnerableVersions}
              checked={onlyVulnerableVersions}
            />
            <span className="react--checkbox" /> Only vulnerable versions
          </label>
        </div>
      );
    } else {
      vulnerableVersionToggleElement = null;
    }
    return (
      <div className="grid">
        <div className="grid__item col-1-1 pb+">
          <div className="grid grid--middle">
            <div className="grid__item col-1-2">
              <div className="grid grid--middle">
                <div className="grid__item col-1-4 font--h7">Version:</div>
                <div className="grid__item col-3-4">
                  <OptionsFilter
                    value={currentVersion}
                    options={versionsArr}
                    onChange={this.updateVersion}
                    multi={false}
                    placeholder={hasVersions ? 'Version' : 'No versions available'}
                    clearable={false}
                  />
                </div>
              </div>
            </div>
            {vulnerableVersionToggleElement}
          </div>
        </div>
        <div className="grid__item col-1-1">{headerElements}</div>
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    libraryState: state.libraryState,
    navigationState: state.navigationState,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(libraryActions, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LibraryViewVersion);
